import * as React from 'react'
import { getCardStyles } from './useStyles'
import { NotificationCardProps } from './typings'

import Card from '@mui/material/Card'
import { NotificationLabel } from './NotificationLabel'
import { useTheme } from '@mui/material/styles'

export const NotificationCard: React.FC<NotificationCardProps> = ({
  bottomContent,
  ...props
}) => {
  const styles = getCardStyles(useTheme())
  return (
    <Card sx={{ maxHeight: '140px', ...styles.card }}>
      <NotificationLabel {...props} />
      {bottomContent}
    </Card>
  )
}
NotificationCard.displayName = 'NotificationCard'
